import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    container: {
        boxSizing: 'border-box',
        padding: '5px',
        gap: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        width: '100%',
    },
}));
